/**
 * Array.sort handles equivalent values and values that are in the correct order differently with respect to how it sorts them compared
 * to other values in the set, so there is an explicit item for equivalent values even though their current order will be kept.
 */
export enum SortComparisonResult {
    KeepCurrentOrder = -1,
    SameValues = 0,
    SwapOrder = 1
}
